export default "__VITE_ASSET__D1kD_YkP__"